import { Box } from "@chakra-ui/react"
import Wrapper from "components/layout/wrapper"

const Component = props => {
    const { fullWidth, children, ...rest } = props
    if (fullWidth) {
        return (
            <Box {...rest} width={"100%"}>
                {children}
            </Box>
        )
    } else {
        return (
            <Wrapper {...rest} py="10px">
                {children}
            </Wrapper>
        )
    }
}

export default function Body({ block, colorMode = "light", margin = null }) {
    const { backgroundColor, backgroundImage, fullWidth, backgroundImageMobile, bgMobileBreakpoint, cssClasses } = block
    // determine background
    let bgColor = backgroundColor ? backgroundColor : "transparent"
    const bgImage = backgroundImage && backgroundImage[0] ? " url(" + backgroundImage[0].url + ")" : "none"
    const bgImageMobile =
        backgroundImageMobile && backgroundImageMobile[0] ? " url(" + backgroundImageMobile[0].url + ")" : bgImage
    const mobileBreakpoint = bgMobileBreakpoint ? bgMobileBreakpoint : "600px"

    return (
        <Component
            className={`body colorMode--${colorMode} ${cssClasses ? cssClasses : null}`}
            backgroundColor={bgColor}
            bgPosition={"center"}
            bgImage={bgImage}
            backgroundSize={"cover"}
            fullWidth={fullWidth}
            css={{
                [`@media (max-width: ${mobileBreakpoint})`]: {
                    backgroundImage: bgImageMobile,
                },
            }}
        >
            <Box m={margin} dangerouslySetInnerHTML={{ __html: block.body }} />
        </Component>
    )
}
